import { useReactTable } from '@tanstack/react-table'
import { Drawer, Button, Divider } from 'rsuite'
import Select from 'react-select'
import { useIntl } from 'react-intl'

type FilterDrawerProps<TData> = {
  open: boolean
  onClose: () => void
  table: ReturnType<typeof useReactTable<TData>>
  data: TData[]
}

export function FilterAnalytics<TData>({ open, onClose, table, data }: FilterDrawerProps<TData>) {
    const intl = useIntl()
    const handleFilterChange = (colId: string, selected: any) => {
        const values = selected ? selected.map((s: any) => s.value) : []
        table.getColumn(colId)?.setFilterValue(values)
    }

  return (
    <Drawer open={open} onClose={onClose} placement="right" size="sm">
      <Drawer.Header>
        <Drawer.Title>Filter</Drawer.Title>
      </Drawer.Header>
      <Drawer.Body>
        {table.getAllLeafColumns().map((column) => {
          const colId = column.id
          const rawValues = new Set(data.map((row: any) => row[colId]))
          const options = Array.from(rawValues)
            .filter((val) => val != null)
            .map((val: any) => ({
              label: String(val),
              value: val,
            }))

          return (
            <div key={colId} className="mb-3">
              <div className="fw-semibold mb-1">{column.columnDef.header as string}</div>
              <Select
                isMulti
                options={options}
                onChange={(selected) => handleFilterChange(colId, selected)}
                value={
                  column.getFilterValue()
                    ? (column.getFilterValue() as any[]).map((v: any) => ({ label: String(v), value: v }))
                    : []
                }
              />
              <Divider />
            </div>
          )
        })}
        <Button appearance="ghost" onClick={onClose}>
          {intl.formatMessage({id:"FORM.ACTION.CLOSE"})}
        </Button>
      </Drawer.Body>
    </Drawer>
  )
}
